module.exports = __webpack_public_path__ + "resources/icon_44_soso_active.29fb46caa9b98218.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_44_soso_active.png
// module id = 431
// module chunks = 0 1 2 3 4